<template>
    <div class="my-checkbox">
      <div v-for="(item, index) in checkboxData" class="row" @click="change(item)" :key=index>
        <div :class="['checkbox', item.status ? 'checkbox-active' :'checkbox-normal']"></div>
        <div v-if="item.type === 2" class="input-container">
          <div class="text">其他</div>
          <div class="input">
            <my-textarea :textareaName="index" :maxLength="100" @changeTextarea="changeTextarea"></my-textarea>
          </div>
        </div>
        <div v-else class="label">{{ item.label }}</div>
      </div>
    </div>
</template>

<script>
import MyTextarea from './MyTextarea'
export default {
  name: 'my-checkbox',
  components: {
    MyTextarea
  },
  props: {
    checkboxData: {
      required: true
    },
    // 新加的
    checkboxName: {
      required: true
    }
  },
  data () {
    return {
    }
  },
  methods: {
    change (data) {
      this.$emit('checkboxChange', data, this.checkboxName)
    },
    changeTextarea (value, name) {
      console.log(value, name)
      const data = this.checkboxData.concat([])[name]
      data.value = value
      this.$emit('checkboxChange', data, this.checkboxName, true)
    }
  }
}
</script>

<style lang="stylus" scoped>
  .my-checkbox
    text-align: left
    margin-left : 1rem
    .row
      margin-bottom: .1rem
      position: relative
      // float: left
      display: inline-block
      width: 100%
      line-height: .4rem
      color: #976e48
      font-size: .4rem
      cursor: pointer
      -webkit-tap-highlight-color: rgba(0,0,0,0)
      .checkbox
        margin-top: 0
        vertical-align: top
        display: inline-block
        width: 23px
        height: 25px
        background-size: 100%
        background-repeat: no-repeat
      .checkbox-active
        background-image: url('../../assets/images/checkbox-active.png')
      .checkbox-normal
        background-image: url('../../assets/images/checkbox-normal.png')
      .label
        display: inline-block
        padding : .1rem
        /*margin-left: 5px;*/
        width: calc(100% - 24px - 15px)
      .input-container
        display: inline-block
        /*margin-left: 5px;*/
        width: calc(100% - 24px - 15px)
        .text
          float: left
        .input
          padding: 0 0
          margin-left: 10px
          float: left
          width: calc(100% - 4em)
</style>



// WEBPACK FOOTER //
// src/servey/compoents/MyCheckbox.vue